export const constants = {
	tempOrderID: '-10',
	paymentMethods: [
		{id: 1, name: 'Cabin'},
		{id: 2, name: 'Account'}
	],
	payerAddedModes: [
		{id: 1, name: 'manual'}, {id: 2, name: 'card'}
	],
	payerAddedBarcodeType: {
		Scan: 'scan',
		Swipe: 'swipe',
	},
	maxPayers: 8,

	discountTypes: {
		amount: 1,
		percentage: 2,
	},

	gratuityTypes: {
		amount: 1,
		percentage: 2,
	},

	legalAgeClasses: {
		alcohol: 1,
		tabacco: 2,
	},

	cancellationReason: {
		reopen: {
			key: 'reopen',
			reason: 'Reopen order',
			date_field: 'reopened_at',
		},

		cancel: {
			key: 'cancel',
			reason: 'Cancel order',
			date_field: 'canceled_at',
		},

		adjust: {
			key: 'adjust',
			reason: 'Adjust order',
			date_field: 'adjusted_at',
		},
	},

	ruleTypes: {
		discountable: {
			key: 'discountable_up_to_daily_amount_and_max_value',
			label: 'Discountable up to a daily amount and max value',
		},

		percent_discountable: {
			key: 'percent_discountable',
			label: 'Percent Discountable',
		},

		free: {
			key: 'unlimited_amount_and_free',
			label: 'Unlimited amount and free',
		},
	},

	alcoholDrinksLimitModal: {
		title: 'Alcohol drinks limit',
		message: 'The 5-minute limit must expire before the alcohol position from the menu can be added to this guest\'s check.',
		ok: 'OK',
	}
}
